import {
  fieldConfigs,
  validateFields,
} from 'components/DataEnrichment/Wizards/validationConfig';

export const types = {
  SET_FILE: 'ENRICHMENT_SET_FILE',
  SET_DATA: 'ENRICHMENT_SET_DATA',
  SET_WIZARD_STEP: 'ENRICHMENT_SET_WIZARD_STEP',
  INCREMENT_WIZARD_STEP: 'ENRICHMENT_INCREMENT_WIZARD_STEP',
  DECREMENT_WIZARD_STEP: 'ENRICHMENT_DECREMENT_WIZARD_STEP',
  RESET_WIZARD_STEP: 'ENRICHMENT_RESET_WIZARD_STEP',
  UPDATE_MAPPING: 'ENRICHMENT_UPDATE_MAPPING',
  SET_ENRICHMENT_STATUS: 'ENRICHMENT_SET_STATUS',
  RESET_WIZARD_STATE: 'ENRICHMENT_RESET_STATE',
  SET_WIZARD_ID: 'ENRICHMENT_SET_WIZARD_ID',
  PROCESS_DATA_ENRICHMENT: 'ENRICHMENT_PROCESS_DATA_ENRICHMENT',
  UPDATE_SETTINGS: 'ENRICHMENT_UPDATE_SETTINGS',
  SET_LIST_DETAILS: 'ENRICHMENT_SET_LIST_DETAILS',
  RESET_MAPPINGS: 'ENRICHMENT_RESET_MAPPINGS',
  SET_SHEET_NAME: 'ENRICHMENT_SET_SHEET_NAME',
  SET_TYPE: 'ENRICHMENT_SET_TYPE',
  SET_DATA_ENRICHMENT_ID: 'ENRICHMENT_SET_DATA_ENRICHMENT_ID',
  SET_ERROR: 'ENRICHMENT_SET_ERROR',
};

export const setDataEnrichmentId = id => dispatch => {
  dispatch({
    type: types.SET_DATA_ENRICHMENT_ID,
    payload: id,
  });
};

export const setEnrichmentFile = file => dispatch => {
  dispatch({
    type: types.SET_FILE,
    payload: file,
  });
};

const aToZArray = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

export const setEnrichmentSheetName = sheetName => dispatch => {
  dispatch({
    type: types.SET_SHEET_NAME,
    payload: sheetName,
  });
};

export const setEnrichmentData = data => (dispatch, getState) => {
  dispatch({
    type: types.RESET_MAPPINGS,
  });

  dispatch({
    type: types.SET_DATA,
    payload: data,
  });

  const settings = getState().enrichment.settings;
  const mappings = getState().enrichment.mappings;
  autoMapColumns(dispatch, data, settings, mappings);
};

const autoMapColumns = (dispatch, data, settings, mappings) => {
  const setMappings = [];
  Object.entries(fieldConfigs).forEach(([id, config]) => {
    if (mappings[id]?.column && mappings[id]?.userAction) {
      dispatch(updateEnrichmentMapping(id, mappings[id]?.column));
      return;
    }

    for (const test of config.testColumn) {
      for (const letter of aToZArray) {
        if (
          test(
            data.map(row => row[letter]),
            settings.includeHeaders
          )
        ) {
          setMappings.push(id);
          dispatch(updateEnrichmentMapping(id, letter));
          return;
        }
      }
    }
    dispatch(updateEnrichmentMapping(id, mappings[id]?.column));
  });
};

export const setEnrichmentWizardStep = step => dispatch => {
  dispatch({
    type: types.SET_WIZARD_STEP,
    payload: step,
  });
};

export const incrementEnrichmentWizardStep = () => dispatch => {
  dispatch({
    type: types.INCREMENT_WIZARD_STEP,
  });
};

export const decrementEnrichmentWizardStep = () => dispatch => {
  dispatch({
    type: types.DECREMENT_WIZARD_STEP,
  });
};

export const resetEnrichmentWizardStep = () => dispatch => {
  dispatch({
    type: types.RESET_WIZARD_STEP,
  });
};

export const updateEnrichmentMapping = (
  mappingId,
  column,
  userAction = false
) => (dispatch, getState) => {
  const data = getState().enrichment.data;
  const settings = getState().enrichment.settings;

  const validation = validateFields(
    mappingId,
    column,
    data,
    settings.includeHeaders
  );

  dispatch({
    type: types.UPDATE_MAPPING,
    payload: { mappingId, update: { column, validation, userAction } },
  });
};

export const setEnrichmentStatus = status => dispatch => {
  dispatch({
    type: types.SET_ENRICHMENT_STATUS,
    payload: status,
  });
};

export const resetEnrichmentWizardState = (
  type = 'email',
  summaryId = null,
  isProcessing = false
) => dispatch => {
  dispatch({
    type: types.RESET_WIZARD_STATE,
    payload: { type, summaryId, isProcessing },
  });
};

export const processDataEnrichment = dataEnrichmentId => dispatch => {
  dispatch({
    type: types.PROCESS_DATA_ENRICHMENT,
    payload: dataEnrichmentId,
  });
};

export const updateEnrichmentSettings = settings => (dispatch, getState) => {
  dispatch({
    type: types.UPDATE_SETTINGS,
    payload: settings,
  });

  const data = getState().enrichment.data;
  const mappings = getState().enrichment.mappings;
  autoMapColumns(dispatch, data, settings, mappings);
};

export const setEnrichedListDetails = listDetails => dispatch => {
  dispatch({
    type: types.SET_LIST_DETAILS,
    payload: listDetails,
  });
};

export const resetEnrichmentMappings = () => dispatch => {
  dispatch({
    type: types.RESET_MAPPINGS,
  });
};

export const setEnrichmentType = type => dispatch => {
  dispatch({
    type: types.SET_TYPE,
    payload: type,
  });
};

export const setEnrichmentError = error => dispatch => {
  dispatch({
    type: types.SET_ERROR,
    payload: error,
  });
};
